import { faDownload, faHourglass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "../Tooltip.js";
import { width } from "@fortawesome/free-solid-svg-icons/faBook";

function DownloadButton({ onClick, isDownloading, text, tooltipText="" }) {
  return (
    <button
      className="basic-button"
      onClick={onClick}
    >
      <Tooltip content={tooltipText}><div backgroundColor="red" style={{width: "100%", height: "100%"}}>
      <FontAwesomeIcon icon={isDownloading ? faHourglass : faDownload}/> {text}</div> </Tooltip>
    </button>
  );
}

export default DownloadButton;